<div class="page-container">
    <div class="header-section">
        <lib-breadcrumb [list]="config.breadcrumbs"></lib-breadcrumb>
        <h2 class="page-title">{{ config.pageTitle }}</h2>
    </div>

    <!-- Search Criteria Panel -->
    <div class="content-wrapper">
        <form [formGroup]="searchForm" (ngSubmit)="handleSearch()" class="search-form-card">
            <div class="search-grid">
                <div class="form-item">
                    <mat-label>Session Name</mat-label>
                    <mat-form-field appearance="outline" class="full-width">
                        <input matInput formControlName="name" />
                    </mat-form-field>
                </div>
                <div class="form-item">
                    <mat-label>Session Date</mat-label>
                    <mat-form-field appearance="outline" class="full-width">
                        <input matInput [matDatepicker]="pickerS" formControlName="beginDate">
                        <mat-datepicker-toggle matSuffix [for]="pickerS"></mat-datepicker-toggle>
                        <mat-datepicker #pickerS></mat-datepicker>
                    </mat-form-field>
                </div>
                <div class="form-actions">
                    <button type="reset" mat-stroked-button color="primary" [disabled]="isLoading" (click)="handleReset()">Reset</button>
                    <button type="submit" mat-flat-button color="primary" [disabled]="isLoading">Search</button>
                </div>
            </div>
        </form>

        <!-- Master Table Panel -->
        <div class="section-container">
            <div class="section-header">
                <h3 class="heading">{{ config.masterTable.panelTitle }}</h3>
                <div class="action-toolbar">
                    <button mat-button color="primary" [disabled]="isMasterAddMode || isLoading" (click)="handleMasterAdd()">
                        <mat-icon>add</mat-icon> Add
                    </button>
                    <button mat-button color="primary" [disabled]="(!isMasterAddMode && !isMasterEditMode && !isDetailAddMode) || isLoading" (click)="handleMasterSave()">
                        <mat-icon>save</mat-icon> Save
                    </button>
                    <button mat-button color="warn" [disabled]="selectedMasterRows.length === 0 || isLoading" (click)="handleMasterDelete()">
                        <mat-icon>delete</mat-icon> Delete
                    </button>
                    <button mat-button color="warn" *ngIf="isMasterAddMode || isMasterEditMode" [disabled]="isLoading" (click)="handleMasterCancel()">
                        <mat-icon>cancel</mat-icon> Cancel
                    </button>
                </div>
            </div>

            <mat-progress-bar *ngIf="isLoading" mode="indeterminate" class="table-progress"></mat-progress-bar>
            
            <div class="responsive-table-wrapper">
                <table mat-table [dataSource]="masterDataSource" matSort class="mat-elevation-z0">
                    <ng-container matColumnDef="select">
                        <th mat-header-cell *matHeaderCellDef class="w-10"></th>
                        <td mat-cell *matCellDef="let element">
                            <mat-checkbox [checked]="selectedMasterRows.includes(element)" (change)="toggleMasterSelection(element, $event.checked)"></mat-checkbox>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="name">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
                        <td mat-cell *matCellDef="let element">
                            <ng-container *ngIf="!element._isEdit">{{ element.name }}</ng-container>
                            <mat-form-field *ngIf="element._isEdit" appearance="outline" class="dense-field">
                                <mat-select [ngModel]="element.sessionId" (selectionChange)="onDropdownSelectionChange(element, config.masterTable.columns[0].options, $event.value, 'master')">
                                    <mat-option *ngFor="let opt of config.masterTable.columns[0].options" [value]="opt.value">{{ opt.label }}</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="beginDate">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Begin Date</th>
                        <td mat-cell *matCellDef="let element">
                            <ng-container *ngIf="!element._isEdit">{{ element.beginDate | date:'dd-MM-yyyy' }}</ng-container>
                            <mat-form-field *ngIf="element._isEdit" appearance="outline" class="dense-field">
                                <input matInput [matDatepicker]="pickerM" [(ngModel)]="element.beginDate" [min]="getMinBeginDate(element)">
                                <mat-datepicker-toggle matSuffix [for]="pickerM"></mat-datepicker-toggle>
                                <mat-datepicker #pickerM></mat-datepicker>
                            </mat-form-field>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="endDate">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>End Date</th>
                        <td mat-cell *matCellDef="let element">
                            <ng-container *ngIf="!element._isEdit">{{ element.endDate | date:'dd-MM-yyyy' }}</ng-container>
                            <mat-form-field *ngIf="element._isEdit" appearance="outline" class="dense-field">
                                <input matInput [matDatepicker]="pickerE" [(ngModel)]="element.endDate" [min]="getMinEndDate(element.beginDate)">
                                <mat-datepicker-toggle matSuffix [for]="pickerE"></mat-datepicker-toggle>
                                <mat-datepicker #pickerE></mat-datepicker>
                            </mat-form-field>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="masterDisplayedColumns; sticky: true"></tr>
                    <tr mat-row *matRowDef="let row; columns: masterDisplayedColumns" [class.selected-row]="singleSelectedMasterRow === row" (click)="onMasterRowClick(row)"></tr>
                </table>
            </div>
        </div>

        <!-- Detail Table Panel -->
        <div class="section-container" *ngIf="singleSelectedMasterRow">
            <div class="section-header">
                <h3 class="heading">{{ config.detailTable.panelTitle }}</h3>
                <div class="action-toolbar">
                    <button mat-button color="primary" [disabled]="isLoading" (click)="handleDetailAdd()">
                        <mat-icon>add</mat-icon> Add
                    </button>
                </div>
            </div>

            <div class="responsive-table-wrapper">
                <table mat-table [dataSource]="detailDataSource" matSort class="mat-elevation-z0">
                    <ng-container matColumnDef="select">
                        <th mat-header-cell *matHeaderCellDef class="w-10"></th>
                        <td mat-cell *matCellDef="let element">
                            <mat-checkbox disabled [checked]="element._isNew"></mat-checkbox>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="name">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
                        <td mat-cell *matCellDef="let element">
                            <ng-container *ngIf="!element._isEdit">{{ element.name }}</ng-container>
                            <mat-form-field *ngIf="element._isEdit" appearance="outline" class="dense-field">
                                <mat-select [ngModel]="element.id" (selectionChange)="onDropdownSelectionChange(element, config.detailTable.columns[0].options, $event.value, 'detail')">
                                    <mat-option *ngFor="let opt of config.detailTable.columns[0].options" [value]="opt.value">{{ opt.label }}</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="activeStartDate">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Active Start Date</th>
                        <td mat-cell *matCellDef="let element">
                            <ng-container *ngIf="!element._isEdit">{{ element.activeStartDate | date:'dd-MM-yyyy' }}</ng-container>
                            <mat-form-field *ngIf="element._isEdit" appearance="outline" class="dense-field">
                                <input matInput [matDatepicker]="pickerDS" [(ngModel)]="element.activeStartDate" 
                                    [min]="parseDate(singleSelectedMasterRow.beginDate)" [max]="parseDate(singleSelectedMasterRow.endDate)">
                                <mat-datepicker-toggle matSuffix [for]="pickerDS"></mat-datepicker-toggle>
                                <mat-datepicker #pickerDS></mat-datepicker>
                            </mat-form-field>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="activeEndDate">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Active End Date</th>
                        <td mat-cell *matCellDef="let element">
                            <ng-container *ngIf="!element._isEdit">{{ element.activeEndDate | date:'dd-MM-yyyy' }}</ng-container>
                            <mat-form-field *ngIf="element._isEdit" appearance="outline" class="dense-field">
                                <input matInput [matDatepicker]="pickerDE" [(ngModel)]="element.activeEndDate"
                                    [min]="parseDate(element.activeStartDate) || parseDate(singleSelectedMasterRow.beginDate)" [max]="parseDate(singleSelectedMasterRow.endDate)">
                                <mat-datepicker-toggle matSuffix [for]="pickerDE"></mat-datepicker-toggle>
                                <mat-datepicker #pickerDE></mat-datepicker>
                            </mat-form-field>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="detailDisplayedColumns; sticky: true"></tr>
                    <tr mat-row *matRowDef="let row; columns: detailDisplayedColumns"></tr>
                </table>
            </div>
        </div>
    </div>
</div>
